The candidate's primary email address.

The value is only set for candidates with `CandidateSource` value `PartnerUpload`.
Values will be unique within a given hirer.
